// SAL6010_R01 전역 상태(Zustand)
// - 필터/목록/선택/편집/상세/삭제선택/컬럼상태/전체건수 등을 관리합니다.
import { ColumnState } from 'ag-grid-community';
import { DateRange } from 'react-day-picker';
import { create } from 'zustand';
import { getCurrentMonthDateRange } from 'src/utils/date/dateUtils';
import { getEmployeeList } from 'src/apis/employeeApi';

import { defaultSAL6010_R01DetailDto, defaultSAL6010_R01HeaderDto, SAL6010_R01DetailDto, SAL6010_R01HeaderDto } from './Dto_SAL6010_R01';

export interface SAL6010_R01Filter {
	compCd: string;
	dateRange: DateRange | undefined;
	custInput: string;
	custNm: string;
	salesEstimateNo: string;
}
export interface Store_SAL6010_R01 {
	SAL6010_R01Filter: SAL6010_R01Filter;
	SAL6010_R01PastFilter: SAL6010_R01Filter;
	setSAL6010_R01Filter: (filter: Partial<Store_SAL6010_R01['SAL6010_R01Filter']>) => void;
	setSAL6010_R01PastFilter: (filter: Store_SAL6010_R01['SAL6010_R01PastFilter']) => void;
	
	SAL6010_R01List: SAL6010_R01HeaderDto[];
	setSAL6010_R01List: (dataList: SAL6010_R01HeaderDto[]) => void;

	editSAL6010_R01: SAL6010_R01HeaderDto | null;
	setEditSAL6010_R01: (editSale: SAL6010_R01HeaderDto | null) => void;

	selectedSAL6010_R01: SAL6010_R01HeaderDto | undefined;
	setSelectedSAL6010_R01: (data: SAL6010_R01HeaderDto | undefined) => void;
	initSelectedSAL6010_R01: () => void;

	deletedSAL6010_R01DetailList: string[];
	setDeletedSAL6010_R01DetailList: (idList: string[]) => void;
	addDeletedSAL6010_R01DetailList: (idList: string[]) => void;
	removeDeletedSAL6010_R01DetailList: (idList?: string[]) => void;

	SAL6010_R01DetailList: SAL6010_R01DetailDto[];
	setSAL6010_R01DetailList: (data: SAL6010_R01DetailDto[]) => void;
	insertSAL6010_R01DetailList: (data: SAL6010_R01DetailDto[], index?: number) => void;
	removeSAL6010_R01DetailList: (index: number) => void;
	updateSAL6010_R01DetailList: (index: number, data: SAL6010_R01DetailDto) => void;

	selectedSAL6010_R01DetailList: string[];
	setSelectedSAL6010_R01DetailList: (idList: string[]) => void;
	addSelectedSAL6010_R01DetailList: (idList: string[]) => void;
	removeSelectedSAL6010_R01DetailList: (idList?: string[]) => void;
	initSelectedSAL6010_R01DetailList: () => void;

	originalSAL6010_R01DetailList: SAL6010_R01DetailDto[];
	setOriginalSAL6010_R01DetailList: (data: SAL6010_R01DetailDto[]) => void;

	// ====== 컬럼 상태(그리드) ======
	columnState: ColumnState[] | null;
	setColumnState: (state: ColumnState[] | null) => void;
	detailColumnState: ColumnState[] | null;
	setDetailColumnState: (state: ColumnState[] | null) => void;

	allCount: number;						setAllCount: (allCount: number) => void;
	detailFetchTrigger: boolean;			setDetailFetchTrigger: (trigger: boolean) => void;

	scrollTop: number | null;
	setScrollTop: (top: number | null) => void;
	detailScrollTop: number | null;
	setDetailScrollTop: (top: number | null) => void;

	// ====== 초기화======
	initData: () => void;

}

export const defaultSAL6010_R01Filter : SAL6010_R01Filter = {
	compCd: '',
	dateRange: getCurrentMonthDateRange(), // 유틸리티 수 사용으로 변경
	custInput: '',
	custNm: '',
	salesEstimateNo: ''
};

export const useSAL6010_R01Store = create<Store_SAL6010_R01>((set) => ({
	SAL6010_R01Filter: defaultSAL6010_R01Filter,
	SAL6010_R01PastFilter: defaultSAL6010_R01Filter,
	setSAL6010_R01Filter: (update) => set((state) => ({
		SAL6010_R01Filter: {
			...state.SAL6010_R01Filter,
			...update
		}
	})),
	setSAL6010_R01PastFilter: (filter: Store_SAL6010_R01['SAL6010_R01PastFilter']) => set((state) => {
		return {
			...state,
			SAL6010_R01PastFilter: filter
		}
	}),

	// ====== 견적 리스트 및 선택/편집 ======
	SAL6010_R01List: [],
	setSAL6010_R01List: (dataList: SAL6010_R01HeaderDto[]) => set((state) => {
		return {
			...state,
			SAL6010_R01List: dataList
		}
	}),

	editSAL6010_R01: defaultSAL6010_R01HeaderDto,
	setEditSAL6010_R01: (editSale: SAL6010_R01HeaderDto | null) => set((state) => {
		return {
			...state,
			editSAL6010_R01: editSale
		}
	}),

	selectedSAL6010_R01: undefined,
	// 매출 행 선택 시 editSales기본 데이터 설정
	setSelectedSAL6010_R01: (data: SAL6010_R01HeaderDto | undefined) => {
		// 동기적으로 기본 데이터 설정
		set((state) => {
			return {
				selectedSAL6010_R01: data,
				selectedSAL6010_R01DetailList: [], deletedSAL6010_R01DetailList: [],
				detailFetchTrigger: true,
				detailScrollTop: null,
			};
		});

		// 비동기적으로 담당자명 조회
		const targetEmpNo = data?.estimateEmpNo || data?.empNo;
		if (targetEmpNo) {
			getEmployeeList('all').then(response => {
				const employee = response.data.data.find(emp => emp.empNo === targetEmpNo);
				if (employee) {
					set((state) => ({
						...state,
						editSAL6010_R01: state.editSAL6010_R01 ? {
							...state.editSAL6010_R01,
							empNm: employee.empNm
						} : null
					}));
				}
			}).catch(error => {
				console.error('담당자 정보 조회 실패:', error);
			});
		}
	},
	initSelectedSAL6010_R01: () => set({ selectedSAL6010_R01: undefined, editSAL6010_R01: defaultSAL6010_R01HeaderDto, SAL6010_R01DetailList: [], detailFetchTrigger: false }),

	// ====== 견적 상세(디테일) 데이터 ======
	SAL6010_R01DetailList: [],
	setSAL6010_R01DetailList: (data: SAL6010_R01DetailDto[]) => set((state) => {
		const newList = data.map((item, index) => ({
			...item,
			valueIndex: item.valueIndex > 0 ? item.valueIndex : index + 1,
			orderIndex: item.orderIndex > -1 ? item.orderIndex : index + 1,
			orderIndexSeq: item.orderIndexSeq > 0 ? item.orderIndexSeq : 0
		}));
		
		return {
			...state,
			SAL6010_R01DetailList: newList
		};
	}),
	insertSAL6010_R01DetailList: (data: SAL6010_R01DetailDto[], index?: number) => set((state) => {
		let newSAL6010_R01DetailList = [...state.SAL6010_R01DetailList];

		let targetRowData = newSAL6010_R01DetailList.find(item => item.valueIndex === index);
		let targetOrderIndex = targetRowData?.orderIndex || 0;
		// 데이터에 orderIndex가 있으면 그것을 사용하고, 없으면 1 (index 파라미터는 배열 위치로만 사용)		

		const newOrderIndexSeq = (targetRowData?.orderIndexSeq || 0) + 1;
		// console.log('targetOrderIndex : ', targetOrderIndex);
		// console.log('newOrderIndexSeq : ', newOrderIndexSeq);
		let maxValueIndex = Math.max(0, ...newSAL6010_R01DetailList.map(item => item.valueIndex || 0)) + 1;

		// newSYS4100_R01List에서 targetOrderIndex인 행들을 빼내서 newOrderIndexSeq 기준으로 다시 정렬
		// newOrderIndexSeq 보다 orderIndexSeq가 작은 행들은 유지. 
		// newOrderIndexSeq 보다 orderIndexSeq가 큰 행들은 기존 orderIndexSeq 값에 1을 더해서 저장.
		const targetRows = newSAL6010_R01DetailList.filter(item => item.orderIndex === targetOrderIndex);
		targetRows.forEach(item => {
			if(item.orderIndexSeq < newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq;
			} else if(item.orderIndexSeq >= newOrderIndexSeq) {
				item.orderIndexSeq = item.orderIndexSeq + 1;
			}
		});

		// targetRows를 newSYS4100_R01List에 대체
		newSAL6010_R01DetailList = newSAL6010_R01DetailList.filter(item => item.orderIndex !== targetOrderIndex);
		newSAL6010_R01DetailList.push(...targetRows);
		
		//새 행을 생성해서 newOrderIndexSeq 값의 행을 저장
		const newData = data.map(item => ({ ...defaultSAL6010_R01DetailDto, ...item, 
			valueIndex: maxValueIndex++,
			orderIndex: targetOrderIndex,
			orderIndexSeq: newOrderIndexSeq
		}));
		if (index !== undefined) {
			newSAL6010_R01DetailList.splice(index, 0, ...newData);
		} else {
			newSAL6010_R01DetailList.push(...newData);
		}

		return {
			...state,
			SAL6010_R01DetailList: newSAL6010_R01DetailList
		}
	}),
	removeSAL6010_R01DetailList: (index: number) => set((state) => {
		const newSAL6010_R01DetailList = [...state.SAL6010_R01DetailList].filter((item) => item.valueIndex !== index);
		return {
			...state,
			SAL6010_R01DetailList: newSAL6010_R01DetailList
		}
	}),
	updateSAL6010_R01DetailList: (valueIndex: number, data: SAL6010_R01DetailDto) => set((state) => {
		const _SAL6010_R01DetailList = state.SAL6010_R01DetailList.map(item =>
			item.valueIndex === valueIndex ? data : item
		);
		return {
			...state,
			SAL6010_R01DetailList: _SAL6010_R01DetailList
		}
	}),
	
	// ====== 행삭제 테이블(품목테이블) 관리 ======
	deletedSAL6010_R01DetailList: [],
	setDeletedSAL6010_R01DetailList: (idList: string[]) => set((state) => {
		return {
			...state,
			deletedSAL6010_R01DetailList: idList
		}
	}),
	addDeletedSAL6010_R01DetailList: (idList: string[]) => set((state) => {
		const _deletedDetailList = [...state.deletedSAL6010_R01DetailList];

		for(const valueIndex of idList) {
			const isInserted = state.SAL6010_R01DetailList.find(item => item.valueIndex === Number(valueIndex) && item.inserted);
			const isModified = state.SAL6010_R01DetailList.find(item => item.valueIndex === Number(valueIndex) && item.isModified);
			if(!isInserted && !isModified) {
				_deletedDetailList.push(valueIndex);
			}
		}
		
		return {
			...state,
			deletedSAL6010_R01DetailList: _deletedDetailList
		}
	}),
	removeDeletedSAL6010_R01DetailList: (idList?: string[]) => set((state) => ({
		...state,
		deletedSAL6010_R01DetailList: [...state.deletedSAL6010_R01DetailList].filter(value => idList ? !idList.includes(value) : false)
	})),
	
	selectedSAL6010_R01DetailList: [],
	setSelectedSAL6010_R01DetailList: (idList: string[]) => set((state) => {
		return {
			...state,
			selectedSAL6010_R01DetailList: idList
		}
	}),
	addSelectedSAL6010_R01DetailList: (idList: string[]) => set((state) => {
		const _selectedSAL6010_R01DetailList = [...state.selectedSAL6010_R01DetailList];
		if(idList.length > 0) {
			_selectedSAL6010_R01DetailList.push(...idList);
		}
		return {
			...state,
			selectedSAL6010_R01DetailList: _selectedSAL6010_R01DetailList
		}
	}),
	removeSelectedSAL6010_R01DetailList: (idList?: string[]) => set((state) => ({
		...state,
		selectedSAL6010_R01DetailList: [...state.selectedSAL6010_R01DetailList].filter(value => idList ? !idList.includes(value) : false)
	})),
	initSelectedSAL6010_R01DetailList: () => set({ selectedSAL6010_R01DetailList: [] }),
	
	originalSAL6010_R01DetailList: [],
	setOriginalSAL6010_R01DetailList: (data: SAL6010_R01DetailDto[]) => set((state) => {
		let newList: SAL6010_R01DetailDto[] = [];
		let valueAndOrderIndex = 1;
		data.forEach((item, index) => {
			newList.push({ 
				...defaultSAL6010_R01DetailDto,
				...item,
				valueIndex: valueAndOrderIndex,
				orderIndex: valueAndOrderIndex,
				orderIndexSeq: valueAndOrderIndex
			});
			valueAndOrderIndex++;
		});
		return {
			...state,
			originalSAL6010_R01DetailList: newList
		}
	}),
	
	// ====== 컬럼 상태(그리드) ======
	columnState: null,
	setColumnState: (state: ColumnState[] | null) => set({ columnState: state }),
	detailColumnState: null,
	setDetailColumnState: (state: ColumnState[] | null) => set({ detailColumnState: state }),
	
	allCount: 0,					setAllCount: (allCount: number) => set({ allCount }),
	detailFetchTrigger: false,		setDetailFetchTrigger: (trigger: boolean) => set({ detailFetchTrigger: trigger }),

	scrollTop: null,
	setScrollTop: (top: number | null) => set({ scrollTop: top }),
	detailScrollTop: null,
	setDetailScrollTop: (top: number | null) => set({ detailScrollTop: top }),
	
	// ====== 초기화======
	initData: () => set((state) => ({
		...state,
		SAL6010_R01Filter: defaultSAL6010_R01Filter,
		SAL6010_R01PastFilter: defaultSAL6010_R01Filter,
		SAL6010_R01List: [],
		selectedSAL6010_R01: undefined,
		SAL6010_R01DetailList: [],
		deletedSAL6010_R01DetailList: [],
		selectedSAL6010_R01DetailList: [],
		originalSAL6010_R01DetailList: [],
		editSAL6010_R01: defaultSAL6010_R01HeaderDto,
		allCount: 0,
		
		columnState: null,
		detailColumnState: null,
		detailFetchTrigger: false,
		scrollTop: null,
		detailScrollTop: null,
	})),
	
	
}));
